/* Pliega los grupos de enlaces del pie en movil.

   Dawn los apila todos abiertos, lo que en un celular convierte el pie en una
   lista de 15 enlaces. Aqui se convierten en acordeon nativo: cuatro titulos
   tocables. En escritorio quedan siempre abiertos y el titulo no es clicable,
   para que se vea exactamente igual que antes. */
(function () {
  var MQ = '(max-width: 749px)';
  var built = false;

  function isMobile() {
    return window.matchMedia && window.matchMedia(MQ).matches;
  }

  function build() {
    if (built) return;
    var blocks = document.querySelectorAll('.footer-block--menu');
    if (!blocks.length) return;

    blocks.forEach(function (block) {
      var heading = block.querySelector('.footer-block__heading, h2, h3');
      var list = block.querySelector('ul');
      if (!heading || !list || block.querySelector('.mb-foot-acc')) return;

      var det = document.createElement('details');
      det.className = 'mb-foot-acc';

      var sum = document.createElement('summary');
      sum.className = 'mb-foot-sum';

      var label = document.createElement('span');
      label.className = heading.className;
      label.textContent = heading.textContent.trim();

      sum.appendChild(label);
      sum.insertAdjacentHTML(
        'beforeend',
        '<svg class="mb-foot-ico" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>'
      );

      det.appendChild(sum);
      block.insertBefore(det, heading);
      heading.remove();
      det.appendChild(list);
    });

    built = true;
    sync();
  }

  function sync() {
    var mobile = isMobile();
    document.querySelectorAll('.mb-foot-acc').forEach(function (d) {
      if (mobile) {
        d.removeAttribute('open');
      } else {
        d.setAttribute('open', 'open');
      }
    });
  }

  function init() {
    build();
    sync();
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', function () { built = false; init(); });
  window.addEventListener('resize', function () {
    clearTimeout(window.__mbFootT);
    window.__mbFootT = setTimeout(sync, 180);
  });
  if (document.readyState !== 'loading') init();
})();
